import { render, staticRenderFns } from "./equipment-information.vue?vue&type=template&id=2c4f8a58&scoped=true"
import script from "./equipment-information.vue?vue&type=script&lang=ts"
export * from "./equipment-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f8a58",
  null
  
)

export default component.exports